import { render, staticRenderFns } from "./tabTable.vue?vue&type=template&id=53d7f2a4"
import script from "./tabTable.vue?vue&type=script&lang=js"
export * from "./tabTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports